/* Bashtian - minimal theme script */
(function () {
  // ---------------------------------------------------------------------
  // The nav's real height, published as --bc-nav-h.
  //
  // The homepage hero sizes itself to the screen minus the nav so the mosaic
  // begins below the fold. Guessing that height does not survive: the nav is
  // taller on a large handset than on a small one, and taller again while the
  // shipping banner is on screen. Measured, and re-measured when the viewport
  // changes.
  // ---------------------------------------------------------------------
  (function () {
    var nav = document.querySelector('nav.top');
    if (!nav) return;
    var apply = function () {
      var h = Math.round(nav.getBoundingClientRect().height);
      if (h > 0) document.documentElement.style.setProperty('--bc-nav-h', h + 'px');
    };
    apply();
    window.addEventListener('resize', apply);
    window.addEventListener('orientationchange', apply);
    if (window.ResizeObserver) { try { new ResizeObserver(apply).observe(nav); } catch (e) {} }
    window.addEventListener('load', apply);
  })();


  // Mobile nav toggle
  var toggle = document.querySelector('.nav-toggle');
  var nav    = document.querySelector('nav.top');
  if (toggle && nav) {
    toggle.addEventListener('click', function () { nav.classList.toggle('open'); });
  }

  // Size selector on product pages - keep selected variant in sync with hidden input
  document.querySelectorAll('.size-opt').forEach(function (b) {
    b.addEventListener('click', function () {
      document.querySelectorAll('.size-opt').forEach(function (x) { x.classList.remove('active'); });
      b.classList.add('active');
      var input = document.querySelector('.selected-variant');
      if (input && b.dataset.variantId) input.value = b.dataset.variantId;
    });
  });

  // Purchase options (one-time vs subscription)
  var poWrap = document.querySelector('.purchase-options');
  if (poWrap) {
    var poData = poWrap.querySelector('[data-po-prices]');
    var poPrices = {};
    try { poPrices = poData ? JSON.parse(poData.textContent) : {}; } catch (e) {}
    var spInput = document.querySelector('.selected-selling-plan');

    function poRefresh() {
      var vInput = document.querySelector('.selected-variant');
      var v = vInput ? poPrices[vInput.value] : null;
      if (!v) return;
      var one = poWrap.querySelector('[data-po-onetime]');
      if (one) one.textContent = v.onetime;
      poWrap.querySelectorAll('[data-po-plan]').forEach(function (el) {
        var pl = v.plans[el.getAttribute('data-po-plan')];
        if (pl) el.textContent = pl;
      });
    }

    poWrap.querySelectorAll('input[name="bashtian_purchase_option"]').forEach(function (r) {
      r.addEventListener('change', function () {
        poWrap.querySelectorAll('.po-opt').forEach(function (o) { o.classList.remove('active'); });
        var opt = r.closest('.po-opt');
        if (opt) opt.classList.add('active');
        if (spInput) spInput.value = r.value;
      });
    });

    document.querySelectorAll('.size-opt').forEach(function (b) {
      b.addEventListener('click', poRefresh);
    });
    poRefresh();
  }

  // Editorial drop cap on first paragraph
  var articleContent = document.querySelector('.article-content');
  if (articleContent) {
    var firstP = articleContent.querySelector('p');
    if (firstP && !firstP.classList.contains('dropcap')) {
      firstP.classList.add('dropcap');
    }
  }

  // Scroll-triggered fade-ins
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('visible'); });
    }, { threshold: 0.15 });
    document.querySelectorAll('.coll-card, .learn-card, .trust-item, .ws-pillar').forEach(function (el) {
      el.classList.add('fade-in');
      io.observe(el);
    });
  }
  // ---------------------------------------------------------------------
  // Cold-chain banner: visible only while The Collection is on screen, or
  // anywhere on a product page. The banner is position:fixed (bashtian.css),
  // so it is out of the document flow until <body> gets .bc-banner-on.
  // ---------------------------------------------------------------------
  (function () {
    var banner = document.querySelector('.ship-banner');
    if (!banner) return;

    // Product pages keep the banner in normal flow (see bashtian.css) and always
    // show it, so there is nothing to toggle here.
    if (document.body.classList.contains('template-product')) return;

    /* Collection pages keep the banner visible and sticky, so there is nothing
       to toggle — but the nav docks underneath it, and that offset needs the
       banner's real height. */
    if (document.body.classList.contains('template-collection') ||
        document.body.classList.contains('template-list-collections')) {
      var setH = function () {
        document.documentElement.style.setProperty('--bc-banner-h', banner.offsetHeight + 'px');
      };
      setH();
      window.addEventListener('resize', setH);
      return;
    }

    var grid      = document.querySelector('.collection-grid');
    var zone      = grid ? (grid.closest('.shopify-section') || grid.closest('section')) : null;
    var queued    = false;

    function measure() {
      document.documentElement.style.setProperty('--bc-banner-h', banner.offsetHeight + 'px');
    }

    var shown = false;

    function update() {
      queued = false;
      if (!zone) return;
      var r = zone.getBoundingClientRect();

      // Hysteresis: it takes more of the section on screen to bring the banner
      // in than to keep it there. Without the gap, a scroll that hovers on the
      // threshold flips the class every frame, which is what read as chop.
      var enterTop = window.innerHeight - 90;
      var enterBot = 90;
      var exitTop  = window.innerHeight - 30;
      var exitBot  = 30;

      var show = shown
        ? (r.top < exitTop && r.bottom > exitBot)
        : (r.top < enterTop && r.bottom > enterBot);

      if (show === shown) return;          // nothing to do: no class churn
      shown = show;
      document.body.classList.toggle('bc-banner-on', show);
    }

    function onScroll() {
      if (!queued) { queued = true; window.requestAnimationFrame(update); }
    }

    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });
  })();

  // ---------------------------------------------------------------------
  // Mobile: move the trust strip out of the hero to sit below The Collection.
  // Restores itself on desktop, so the same DOM serves both breakpoints.
  // ---------------------------------------------------------------------
  (function () {
    var strip = document.querySelector('.hero-strip');
    if (!strip) return;
    var grid = document.querySelector('.collection-grid');
    var zone = grid ? (grid.closest('.shopify-section') || grid.closest('section')) : null;
    if (!zone) return;

    var homeParent = strip.parentNode;
    var homeAnchor = strip.nextSibling;
    var mq = window.matchMedia('(max-width: 720px)');

    function apply() {
      if (mq.matches) {
        if (strip.previousElementSibling !== zone) {
          zone.parentNode.insertBefore(strip, zone.nextSibling);
        }
        strip.classList.add('bc-relocated');
      } else {
        if (strip.parentNode !== homeParent) {
          homeParent.insertBefore(strip, homeAnchor);
        }
        strip.classList.remove('bc-relocated');
      }
    }

    apply();
    if (mq.addEventListener) { mq.addEventListener('change', apply); }
    else if (mq.addListener) { mq.addListener(apply); }
  })();

  // ---------------------------------------------------------------------
  // Story carousel: swipe on touch, arrows on desktop, dots on both.
  // ---------------------------------------------------------------------
  document.querySelectorAll('[data-bc-carousel]').forEach(function (car) {
    var track  = car.querySelector('[data-bc-track]');
    var slides = [].slice.call(car.querySelectorAll('.bc-carousel__slide'));
    var dots   = car.querySelector('[data-bc-dots]');
    var prev   = car.querySelector('[data-bc-prev]');
    var next   = car.querySelector('[data-bc-next]');
    if (!track) return;

    // A single slide needs no controls at all.
    if (slides.length < 2) {
      [dots, prev, next].forEach(function (el) { if (el) el.remove(); });
      return;
    }

    function index() {
      return Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
    }
    function goTo(i) {
      track.scrollTo({ left: track.clientWidth * Math.max(0, Math.min(slides.length - 1, i)), behavior: 'smooth' });
    }

    if (dots) {
      slides.forEach(function (_, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Show image ' + (i + 1) + ' of ' + slides.length);
        b.addEventListener('click', function () { goTo(i); });
        dots.appendChild(b);
      });
    }

    function sync() {
      if (!dots) return;
      var i = index();
      [].forEach.call(dots.children, function (d, j) {
        d.setAttribute('aria-current', j === i ? 'true' : 'false');
      });
    }

    var settle;
    track.addEventListener('scroll', function () {
      clearTimeout(settle);
      settle = setTimeout(sync, 60);
    }, { passive: true });

    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });
    window.addEventListener('resize', sync);

    /* Always open on the first image. A scroll-snap track keeps its position
       across a reload, so without this the strip could come back showing
       whichever slide the visitor left it on. */
    track.scrollLeft = 0;
    window.addEventListener('pageshow', function () { track.scrollLeft = 0; sync(); });
    sync();
  });
  // ---------------------------------------------------------------------
  // Product editorial -> tabs. Progressive enhancement: the panels render
  // stacked without JS, and only collapse into a tab strip once this runs.
  // ---------------------------------------------------------------------
  // ---------------------------------------------------------------------
  // "Pick a Roe" and "FAQ" join the editorial tabs.
  //
  // The comparison table and the questions are their own Shopify sections, so
  // they stay separately editable in Customize — but on the page they belong
  // with the rest of the product's reading material rather than as two more
  // bands below it. Their content is moved into the tab strip as two extra
  // panels before the tab builder runs, and the now-empty section wrappers
  // are removed. Without JS all three simply render in sequence, as before.
  // ---------------------------------------------------------------------
  (function () {
    var tabs = document.querySelector('[data-bc-tabs] .wrap');
    if (!tabs) return;

    [
      { sel: '.bc-compare', body: '.bc-compare__scroll', label: 'Pick a Roe' },
      { sel: '.bc-faq',     body: '.bc-faq__list',       label: 'FAQ' }
    ].forEach(function (spec) {
      var src = document.querySelector(spec.sel);
      if (!src) return;
      var body = src.querySelector(spec.body);
      if (!body) return;

      var panel = document.createElement('div');
      panel.className = 'editorial-block bc-tabs__imported';
      panel.setAttribute('data-bc-panel', '');
      panel.setAttribute('data-bc-label', spec.label);

      var col = document.createElement('div');
      col.className = 'content-col';

      // The section's own lede is worth keeping; its heading is replaced by
      // the tab's own label, so it would only repeat it.
      var lede = src.querySelector('.lede');
      if (lede) col.appendChild(lede.cloneNode(true));
      col.appendChild(body);
      panel.appendChild(col);
      tabs.appendChild(panel);

      var wrapper = src.closest('.shopify-section') || src;

      // A Shopify section carries its own <style> inside the wrapper. Removing
      // the wrapper therefore deletes the CSS along with it, which is what
      // left the imported table and questions completely unstyled. The style
      // elements are moved to <head> before the wrapper goes.
      if (wrapper) {
        [].slice.call(wrapper.querySelectorAll('style')).forEach(function (st) {
          document.head.appendChild(st);
        });
        if (wrapper.parentNode) wrapper.parentNode.removeChild(wrapper);
      }
    });
  })();

  (function () {
    var section = document.querySelector('[data-bc-tabs]');
    if (!section) return;
    var nav    = section.querySelector('[data-bc-tabnav]');
    var panels = [].slice.call(section.querySelectorAll('[data-bc-panel]'));
    if (!nav || panels.length < 2) return;

    function show(i) {
      panels.forEach(function (p, j) {
        p.classList.toggle('is-active', j === i);
        p.setAttribute('aria-hidden', j === i ? 'false' : 'true');
      });
      [].forEach.call(nav.children, function (b, j) {
        b.setAttribute('aria-selected', j === i ? 'true' : 'false');
        b.tabIndex = j === i ? 0 : -1;
      });
    }

    panels.forEach(function (panel, i) {
      var id = 'bc-panel-' + i;
      panel.id = id;
      panel.setAttribute('role', 'tabpanel');

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bc-tabs__btn';
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-controls', id);
      b.textContent = panel.getAttribute('data-bc-label') || ('Section ' + (i + 1));
      b.addEventListener('click', function () { show(i); });
      b.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return;
        e.preventDefault();
        var n = (i + d + panels.length) % panels.length;
        show(n);
        nav.children[n].focus();
      });
      nav.appendChild(b);
    });

    section.classList.add('bc-tabs-ready');
    show(0);
  })();
  // ---------------------------------------------------------------------
  // Reviews gallery. Judge.me renders a vertical list late, so we watch for
  // it, then: page the row three-at-a-time, and give any review that is
  // taller than its clamp a real "Read more" that opens the card in place.
  // Nothing is cropped and nothing fades — the text is either clamped with an
  // affordance to open it, or fully shown.
  // ---------------------------------------------------------------------
  (function () {
    var host = document.querySelector('.bc-reviews');
    if (!host) return;

    function addReadMore(item) {
      if (item.dataset.bcRm) return;
      var body = item.querySelector('.jm-review-body-wrapper');
      var content = item.querySelector('.jm-review-content') || body;
      if (!body || !content) return;
      item.dataset.bcRm = '1';

      // The clamp is a max-height, so this comparison is reliable. Short
      // reviews get no button at all — the affordance only appears when there
      // is genuinely more to read.
      if (body.scrollHeight - body.clientHeight < 8) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'bc-readmore';
      btn.textContent = 'Read more';
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('bc-open');
        btn.textContent = open ? 'Read less' : 'Read more';
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      content.appendChild(btn);
    }

    function build(list) {
      if (list.dataset.bcRevReady) return;
      list.dataset.bcRevReady = '1';

      [].slice.call(list.querySelectorAll('.jm-review-item')).forEach(addReadMore);

      // Lift the real "Write a review" button out of Judge.me's header card
      // before that card is hidden, so it keeps working, and drop it below the
      // gallery where it now belongs.
      var widget = list.closest('.jm-review-widget') || host;
      var write = null;
      [].slice.call(widget.querySelectorAll('button, a')).forEach(function (b) {
        if (!write && /write a review/i.test((b.textContent || '').trim())) write = b;
      });

      // One wrapper for both, so spacing comes from gap and can't be zeroed
      // by Judge.me's margin resets.
      var footer = document.createElement('div');
      footer.className = 'bc-rev-footer';

      var nav = document.createElement('div');
      nav.className = 'bc-rev-nav';
      var prev = document.createElement('button');
      var next = document.createElement('button');
      prev.type = next.type = 'button';
      prev.setAttribute('aria-label', 'Previous reviews');
      next.setAttribute('aria-label', 'Next reviews');
      prev.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      next.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      nav.appendChild(prev);
      nav.appendChild(next);
      footer.appendChild(nav);
      list.parentNode.insertBefore(footer, list.nextSibling);

      function step() {
        var card = list.querySelector('.jm-review-item');
        return card ? card.getBoundingClientRect().width + 20 : list.clientWidth;
      }
      function sync() {
        var max = list.scrollWidth - list.clientWidth;
        nav.style.display = max > 4 ? 'flex' : 'none';
        prev.disabled = list.scrollLeft <= 2;
        next.disabled = list.scrollLeft >= max - 2;
      }
      prev.addEventListener('click', function () { list.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { list.scrollBy({ left:  step(), behavior: 'smooth' }); });

      if (write) {
        var actions = document.createElement('div');
        actions.className = 'bc-rev-actions';
        actions.appendChild(write);
        footer.appendChild(actions);
      }

      var t;
      list.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(sync, 60); }, { passive: true });
      window.addEventListener('resize', sync);
      sync();

      // Judge.me repaints the list when filters or paging change.
      new MutationObserver(function () {
        [].slice.call(list.querySelectorAll('.jm-review-item')).forEach(addReadMore);
        sync();
      }).observe(list, { childList: true });
    }

    var list = host.querySelector('.jdgm-review-list');
    if (list) { build(list); return; }

    var seen = new MutationObserver(function () {
      var l = host.querySelector('.jdgm-review-list');
      if (l) { build(l); seen.disconnect(); }
    });
    seen.observe(host, { childList: true, subtree: true });
    setTimeout(function () { seen.disconnect(); }, 20000);
  })();
  // ---------------------------------------------------------------------
  // Caviar dropdown. Desktop opens on hover via CSS; this handles touch and
  // keyboard, where hover does not apply.
  // ---------------------------------------------------------------------
  (function () {
    var items = [].slice.call(document.querySelectorAll('[data-nav-sub]'));
    if (!items.length) return;

    function closeAll(except) {
      items.forEach(function (li) {
        if (li === except) return;
        li.classList.remove('is-open');
        var b = li.querySelector('.nav-sub-toggle');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }

    items.forEach(function (li) {
      var btn = li.querySelector('.nav-sub-toggle');
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var open = !li.classList.contains('is-open');
        closeAll(li);
        li.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-nav-sub]')) closeAll(null);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeAll(null);
    });
  })();
  // ---------------------------------------------------------------------
  // Image protection.
  //
  // Worth being clear about what this is: a deterrent, not security. Anyone
  // can still screenshot, open devtools, or read the CDN URL from source.
  // What it stops is the casual right-click-save and drag-to-desktop, which
  // is the vast majority of casual copying.
  //
  // Deliberately narrow: it only blocks the context menu and drag ON IMAGES,
  // so right-clicking text to copy, or opening a link in a new tab, still
  // works normally.
  // ---------------------------------------------------------------------
  (function () {
    function isImage(el) {
      return el && (el.tagName === 'IMG' || el.tagName === 'PICTURE' ||
                    (el.closest && el.closest('picture')));
    }

    document.addEventListener('contextmenu', function (e) {
      if (isImage(e.target)) e.preventDefault();
    });

    document.addEventListener('dragstart', function (e) {
      if (isImage(e.target)) e.preventDefault();
    });
  })();



  // ---------------------------------------------------------------------
  // Review photographs. The small plate in a review card opens the full
  // image in place: the plate's own rectangle grows into the final one, so
  // the picture appears to come from where it was rather than fading in over
  // the page. One shared overlay, built once, on first use.
  // ---------------------------------------------------------------------
  (function () {
    var triggers = [].slice.call(document.querySelectorAll('[data-bc-lightbox]'));
    if (!triggers.length) return;

    var box, frame, img, closeBtn, lastFocus, open = false;

    function build() {
      box = document.createElement('div');
      box.className = 'bc-lightbox';
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.hidden = true;

      frame = document.createElement('figure');
      frame.className = 'bc-lightbox__frame';
      img = document.createElement('img');
      img.alt = '';
      frame.appendChild(img);

      closeBtn = document.createElement('button');
      closeBtn.type = 'button';
      closeBtn.className = 'bc-lightbox__close';
      closeBtn.setAttribute('aria-label', 'Close');
      closeBtn.innerHTML = '&times;';

      box.appendChild(frame);
      box.appendChild(closeBtn);
      document.body.appendChild(box);

      box.addEventListener('click', function (e) { if (e.target === box) close(); });
      closeBtn.addEventListener('click', close);
      document.addEventListener('keydown', function (e) { if (open && e.key === 'Escape') close(); });
    }

    function show(trigger) {
      if (!box) build();
      lastFocus = trigger;
      open = true;

      var thumb = trigger.querySelector('img');
      var full  = trigger.getAttribute('data-full');
      var from  = trigger.getBoundingClientRect();

      // The thumbnail is already decoded, so showing it first means the frame
      // never opens empty and never resizes under the animation — the full
      // image swaps in behind it once it is ready.
      img.src = thumb ? (thumb.currentSrc || thumb.src) : full;
      img.alt = trigger.getAttribute('aria-label') || '';

      box.hidden = false;
      document.documentElement.classList.add('bc-lightbox-on');
      box.classList.add('is-open');

      // Measure after a layout pass so the frame has its real resting size.
      // Animating from a frame measured before the image had dimensions is
      // what produced the occasional wild jump.
      requestAnimationFrame(function () {
        var to = frame.getBoundingClientRect();
        if (!to.width || !to.height) return;

        var dx = (from.left + from.width / 2)  - (to.left + to.width / 2);
        var dy = (from.top  + from.height / 2) - (to.top  + to.height / 2);
        var s  = Math.max(from.width / to.width, 0.05);

        frame.style.willChange = 'transform, opacity';

        // The Web Animations API runs this off the main thread and cannot be
        // interrupted half-applied the way two chained rAFs plus a CSS
        // transition could be.
        if (frame.animate) {
          var anim = frame.animate(
            [
              { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + s + ')', opacity: 0.55 },
              { transform: 'none', opacity: 1 }
            ],
            { duration: 460, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' }
          );
          anim.onfinish = function () {
            anim.cancel();
            frame.style.willChange = '';
          };
        } else {
          frame.style.willChange = '';
        }

        // Swap to the full-resolution file once it has decoded, so the
        // exchange never lands mid-animation.
        if (full && full !== img.src) {
          var pre = new Image();
          pre.onload = function () {
            var apply = function () { img.src = full; };
            if (pre.decode) { pre.decode().then(apply).catch(apply); } else { apply(); }
          };
          pre.src = full;
        }
      });

      closeBtn.focus();
    }

    function close() {
      if (!open) return;
      open = false;
      box.classList.remove('is-open');
      document.documentElement.classList.remove('bc-lightbox-on');
      var done = false;
      function finish() {
        if (done) return;
        done = true;
        box.hidden = true;
        frame.style.willChange = '';
        img.removeAttribute('src');
        if (lastFocus) lastFocus.focus();
      }
      box.addEventListener('transitionend', finish, { once: true });
      setTimeout(finish, 420);
    }

    triggers.forEach(function (t) {
      t.addEventListener('click', function () { show(t); });
    });
  })();

})();
